import { CheckIcon, FlagIcon, TrashIcon, XMarkIcon } from '@heroicons/react/24/outline'

export default function BulkActionBar({ selectedCount, onResolve, onFlag, onDelete, onCancel }) {
  if (selectedCount === 0) return null

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 bg-slate-900 text-white rounded-xl shadow-2xl px-5 py-3 flex items-center space-x-4">
      <span className="text-xs font-medium">{selectedCount} selected</span>
      <div className="h-4 w-px bg-slate-700" />
      <button
        onClick={onResolve}
        className="flex items-center space-x-1.5 px-3 py-1.5 bg-emerald-600 text-xs font-medium rounded-lg hover:bg-emerald-700 transition-colors"
      >
        <CheckIcon className="h-3.5 w-3.5" />
        <span>Resolve All</span>
      </button>
      <button
        onClick={onFlag}
        className="flex items-center space-x-1.5 px-3 py-1.5 bg-amber-600 text-xs font-medium rounded-lg hover:bg-amber-700 transition-colors"
      >
        <FlagIcon className="h-3.5 w-3.5" />
        <span>Flag All</span>
      </button>
      <button
        onClick={onDelete}
        className="flex items-center space-x-1.5 px-3 py-1.5 bg-red-600 text-xs font-medium rounded-lg hover:bg-red-700 transition-colors"
      >
        <TrashIcon className="h-3.5 w-3.5" />
        <span>Delete All</span>
      </button>
      <button onClick={onCancel} className="p-1 hover:bg-slate-800 rounded-lg transition-colors">
        <XMarkIcon className="h-4 w-4" />
      </button>
    </div>
  )
}
